import React from 'react';
import { motion } from 'framer-motion';
import { useCountdown } from '../hooks/useCountdown';
export function FinalCTA() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="py-32 px-4 bg-deep-black relative overflow-hidden" data-id="element-43">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(10,42,255,0.3)_0%,rgba(13,13,13,1)_60%)] pointer-events-none" data-id="element-44" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-46">
          <h2 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-47">
            Tu próxima conversación ya no va a ser igual.
          </h2>

          <p className="text-xl md:text-2xl text-smoke/90 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-48">
            Cada día que pasás sin saber leer el cuerpo es un día que alguien
            más sabe más sobre vos de lo que vos sabés sobre ellos.
          </p>

          <div className="mb-10" data-id="element-49">
            <span className="text-smoke/50 line-through text-2xl mr-4" data-id="element-50">
              $49.990
            </span>
            <span className="text-6xl font-heading font-bold text-gold" data-id="element-51">
              $19.990 <span className="text-2xl text-gold/70" data-id="element-52">ARS</span>
            </span>
            <p className="text-smoke/80 mt-4 text-lg" data-id="element-53">
              Pack completo · 6 tomos · 6 bonos · Acceso inmediato
            </p>
          </div>

          <a href="#checkout" className="inline-block w-full md:w-auto bg-electric-blue text-white font-heading font-bold text-xl md:text-2xl px-12 py-6 rounded-xl shadow-glow-blue hover:bg-blue-600 transition-all transform hover:scale-105 animate-pulse-glow mb-6" data-id="element-54">
            🧠 QUIERO EL PACK COMPLETO AHORA
          </a>

          <div className="flex justify-center items-center gap-6 text-sm text-smoke/70 mb-10" data-id="element-55">
            <span data-id="element-56">🔒 Pago seguro</span>
            <span data-id="element-57">⚡ Acceso inmediato</span>
            <span data-id="element-58">↩️ Garantía 7 días</span>
          </div>

          <div className="inline-block bg-black/50 border border-white/10 px-6 py-3 rounded-full" data-id="element-59">
            <span className="text-smoke/80 mr-2" data-id="element-60">Esta oferta vence en:</span>
            <span className="font-heading font-bold text-gold text-xl tracking-wider" data-id="element-61">
              {hours}:{minutes}:{seconds}
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}